import React, { useEffect } from 'react'
import TaxiServiceData from './TaxiServiceData'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Resale } from '../home/Resale';
import heroImg from '../../assets/Banner.png';

const TexiServiceList = () => {
    const location=useLocation();
    
    const navigate = useNavigate();
     useEffect(() => {
          window.scrollTo(0, 0);
      }, [location.pathname]);
  
            
    return (
        <>

            <section className="relative h-[30vh] sm:h-[60vh] w-full mt-[70px]">
                <img
                    src={heroImg}
                    alt="About Hero"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-pink-600/80 to-pink-500/80"></div>
                <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4 sm:px-10 md:px-20 text-center">
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-serif">Taxi Services</h1>
                    <p className="text-lg sm:text-xl md:text-2xl mt-4 max-w-3xl">
                        Explore India with custom tour packages for Rajasthan, Jaipur, and beyond
                    </p>
                </div>
            </section>
            <div className="space-y-6 p-4 mt-[50px] mb-[50px]">
                <h1 className='text-center font-semibold text-3xl text-gray-800 mb-[30px]'>One Way & Round Trip Taxi Service Across India</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mx-5">
                    {TaxiServiceData.map((taxiData, index) => (
                        <div key={index}
                            onClick={() => navigate(`/taxi-service/${taxiData.city.toLowerCase()}`, { state: { taxiData } })}
                            className="cursor-pointer">
                            <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-transform duration-300 hover:scale-105 p-3 text-center border-2 border-pink-200 hover:bg-pink-200">
                                <img
                                    src={taxiData.img}
                                    alt={taxiData.city}
                                    className="w-full h-40 object-cover rounded-md"
                                />
                                <h3 className="text-xl font-semibold text-gray-900 mt-3">{taxiData.city}</h3>
                                <p className="text-gray-600 text-sm mt-1">Taxi Service</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Resale />
        </>
    )
}
export default TexiServiceList

// import React, { useEffect } from 'react'
// import TaxiServiceData from './TaxiServiceData'
// import { Link, useNavigate } from 'react-router-dom'
// import { Resale } from '../home/Resale';

// const TexiServiceList = () => {
//     const navigate = useNavigate();
//     useEffect(() => {
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     }, []);
    
//     return (
//         <>
//             <div className="space-y-6 p-4 mt-[100px] mb-[50px]">
//                 <h1 className='text-center font-semibold text-3xl text-gray-800 mb-[30px]'>One Way & Round Trip Taxi Service Across India</h1>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mx-5">
//                     {TaxiServiceData.map((taxiData, index) => (
//                         <div key={index}
//                             onClick={() => navigate(`/taxi-service/${taxiData.city.toLowerCase()}`, { state: { taxiData } })}
//                             className="cursor-pointer">
//                             <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-transform duration-300 hover:scale-105 p-3 text-center border-2 border-pink-200 hover:bg-pink-200">
//                                 <img
//                                     src={taxiData.img}
//                                     alt={taxiData.city}
//                                     className="w-full h-40 object-cover rounded-md"
//                                 />
//                                 <h3 className="text-xl font-semibold text-gray-900 mt-3">{taxiData.city}</h3>
//                                 <p className="text-gray-600 text-sm mt-1">Taxi Service</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <Resale />
//         </>
//     )
// }
// export default TexiServiceList